import type { ComponentType } from "react";
import {
  Brain,
  FileText,
  FlaskConical,
  Lightbulb,
  Sparkles,
  Target,
} from "lucide-react";
import type { SourceType } from "@/types/sourceTypes";

export { SOURCE_TYPES } from "@/types/sourceTypes";

export const SOURCE_TYPE_LABEL: Record<SourceType, string> = {
  document: "Documents",
  assumption: "Assumptions",
  hypothesis: "Hypotheses",
  experiment: "Experiments",
  learning: "Learnings",
  insight: "Insights",
};

export const SOURCE_TYPE_DESCRIPTION: Record<SourceType, string> = {
  document: "Uploaded files and references",
  assumption: "Core beliefs to validate",
  hypothesis: "Testable statements",
  experiment: "Validation runs and plans",
  learning: "Captured learnings",
  insight: "Synthesis insights",
};

export const SOURCE_TYPE_ICON: Record<SourceType, ComponentType<{ className?: string }>> = {
  document: FileText,
  assumption: Lightbulb,
  hypothesis: Target,
  experiment: FlaskConical,
  learning: Brain,
  insight: Sparkles,
};
